
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/increase-image-quality",
      function () {
        return require("private-next-pages/increase-image-quality/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/increase-image-quality"])
      });
    }
  